import { put, call, takeEvery, select } from '@redux-saga/core/effects';
import { reportMessage } from 'lib/error';

import { svpApiClient } from 'services';
import SELECT_NEWSROOM from 'store/newsroom/actionTypes';
import { selectNewsroom } from 'store/newsroom/selectors';

import { linkedProvidersFetchSuccess, linkedProvidersFetchError } from './actions';

/**
 *
 * @returns {Generator<*, void, ?>}
 */
export function* fetchLinkedProviders() {
    const currentNewsroom = yield select(selectNewsroom);
    try {
        const linked = yield call(svpApiClient.fetchLinkedProviders, { provider: currentNewsroom });

        yield put(linkedProvidersFetchSuccess({ linked }));
    } catch (error) {
        reportMessage({
            message: 'Failed to fetch linked providers',
            error,
        });
        yield put(linkedProvidersFetchError());
    }
}

export default [takeEvery(SELECT_NEWSROOM, fetchLinkedProviders)];
